import React, { useContext, useEffect, useState } from 'react';
import { PlusCircle, Search } from 'react-feather';
import { BaseFloatMenu, TextField, ToastAlert } from '../../UIElements';
import toast from 'react-hot-toast';
import Skeleton from 'react-loading-skeleton';
import { ReportsContext } from '../../../context/reports';
import { CreateReportDialog } from '../../Dialogs/reports';
import './index.scss';
import ReportsList from './ReportsList';
import RestrictedUI from '../../RestrictedUI';
import { PERMISSIONS } from '../../../constants/memberPermissions';
import { ENTITIES } from '../../../constants/entities';
import { useIntl } from 'react-intl';

const ReportsSidebar = () => {
    const intl = useIntl();

    const {
        reports = [],
        loading,
        onCreateReport,
        selectedReport,
        setSelectedReport,
        selectedProject,
        newReportMenu = {},
    } = useContext(ReportsContext);

    // -------- SEARCH AND FILTERING ----------
    const [showSearch, setShowSearch] = useState(false);
    const [search, setSearch] = useState('');
    const [filteredReports, setFilteredReports] = useState();

    useEffect(() => {
        setFilteredReports(reports);
    }, [reports]);

    const handleShowInput = () => {
        setShowSearch(!showSearch);
        if (showSearch) {
            setSearch('');
            setFilteredReports(reports);
        }
    };

    const handleChange = (e) => {
        const term = e.target.value;

        setSearch(term);
        filterReports(term);
    };

    const filterReports = (term) => {
        const filtered = reports.filter((report) =>
            report.name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredReports(filtered);
    };

    const handleCreateReport = async (reportName) => {
        const { error } = await onCreateReport(reportName, selectedProject.id);

        if (error) {
            toast.error(intl.formatMessage({ id: 'general_error' }));
            return;
        }

        toast.success(
            intl.formatMessage({ id: 'report_created_successfully' })
        );
        newReportMenu.handleMenu();
    };

    return (
        <div className="cg-reports-sidebar">
            <ToastAlert position="bottom-center" />
            <div className="cg-reports-sidebar__header">
                <div ref={newReportMenu.menuRef}>
                    <span> {intl.formatMessage({ id: 'reports' })} </span>
                    <div>
                        <Search onClick={handleShowInput} />
                        <RestrictedUI
                            to={PERMISSIONS.EDIT}
                            entity={ENTITIES.REPORTS}
                        >
                            <PlusCircle onClick={newReportMenu.handleMenu} />
                        </RestrictedUI>
                    </div>

                    <div style={{ position: 'fixed', zIndex: 150 }}>
                        {newReportMenu.showMenu && (
                            <BaseFloatMenu top={15} left={75}>
                                <CreateReportDialog
                                    onCreate={handleCreateReport}
                                    onClose={newReportMenu.handleMenu}
                                    intl={intl}
                                    loading={loading}
                                />
                            </BaseFloatMenu>
                        )}
                    </div>
                </div>

                {showSearch && (
                    <form className="animate__animated animate__fadeIn cg-reports-sidebar__search">
                        <TextField
                            iconBefore={Search}
                            inputProps={{
                                onChange: handleChange,
                                value: search,
                                placeholder: intl.formatMessage({
                                    id: 'type_something',
                                }),
                                autoFocus: true,
                            }}
                        />
                        <span onClick={handleShowInput}>
                            {intl.formatMessage({ id: 'hide_search' })}
                        </span>
                    </form>
                )}
            </div>

            {loading && (
                <div className="cg-reports-sidebar__skeleton">
                    <Skeleton count={10} />
                </div>
            )}

            {!loading && (
                <ReportsList
                    reports={filteredReports}
                    intl={intl}
                    onSelectReport={setSelectedReport}
                    selectedReport={selectedReport}
                />
            )}
        </div>
    );
};

export default ReportsSidebar;
